module.exports = __webpack_public_path__ + "static/34-PURPOSE-IS-THE-NEW-BLACK-a7ee10233a5962c36b66177413fc45c6.jpg";